import { render, staticRenderFns } from "./SampleForm.vue?vue&type=template&id=3cc1ca06&scoped=true&"
import script from "./SampleForm.vue?vue&type=script&lang=js&"
export * from "./SampleForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc1ca06",
  null
  
)

export default component.exports